import { BaseRequestModel } from '../../../base/base.request.model';
import { AppChannelModel } from './app-channel.model';

export class ProductRequestModel extends BaseRequestModel {
  dmaID!: string;
  returnAppChannels!: string;
  returnPromotions!: string;
  appChannels!: AppChannelModel[];
  returnLocaleDisplayName!: string;
  rateType!: string;
}
